<template>
  <div class="table-rows-head" :class="{ 
    'table-rows-head--active': isActive,
    'table-rows-head--clickable': isClickable,
  }">
    <div class="table-rows-head__box" @click="handleClose()">
      <BorderStarIcon v-if="icon === 'star'"/>
      <FilterIcon v-else-if="icon === 'filter'" />
      <ClockIcon v-else-if="icon === 'clock'" />
      <SearchIcon v-else-if="icon === 'search'" :style="{ height: '12px', width: '12px' }"/>
      {{ text }}
      <CircledCrossIcon class="table-rows-head__close" v-if="isActive" />
    </div>
    <ArrowChevron class="table-rows-head__arrow" 
      :class="{ 'table-rows-head__arrow--rotate': isExpanded }"
      v-if="isClickable"
    />
  </div>
</template>

<script setup>
  import { Props } from './props';
  //-----------------------------------------
  import BorderStarIcon from '@shared/UI/SVG/BorderStarIcon.vue';
  import ClockIcon from '@shared/UI/SVG/ClockIcon.vue';
  import CircledCrossIcon from '@shared/UI/Svg/ui/CircledCross.vue';
  import FilterIcon from '@shared/UI/SVG/FilterIcon.vue';
  import ArrowChevron from '@shared/UI/Svg/ui/ArrowChevron.vue';
  import SearchIcon from '@shared/UI/Svg/ui/Search.vue';
  //-----------------------------------------
  const props = defineProps(Props());
  const emit = defineEmits(['close']);
  //-----------------------------------------
  const handleClose = () => { 
    if (!props.isActive) return;
    emit('close'); 
  };
</script>

<style lang="scss" scoped>
  @import "./styles";
</style>